import { Grid, Typography } from '@material-ui/core';

const Home = () => {
         //want to put tutorial video
    return (
        <Grid
            container
            alignItems="center"
            justify="center"
            direction="column"
            style={{ minHeight: '80vh' }}
        >
            <Grid item >
                <Typography
                    align="center"
                    color="textPrimary"
                    gutterBottom
                    variant="h1"
                    component="h1"
                >
                    Welcome to DCS ISRAEL Servers Statistics
                </Typography>
                <Typography
                    align="center"
                    color="textSecondary"
                    variant="h6"
                    component="h4"
                >
                    Made <strong>By</strong> and <strong>For</strong> the community
                </Typography>
            </Grid >
        </Grid >
    )
}
export default Home;
